/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ChatArrowRightIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABf0lEQVR4nN2UPUsDQRCGo/iBrRI/fk3aQzI7c8I4I2qbTlCIWF4tolgKWqqIP0FBBBHEUhELE4yVlY2IxkIiRy4Sc4vZu1zlwlTLPc/eO7Oby/3r5XnesPGFDcqhQakC6SugvgNqBVD3w71CoTCQCg4kMwalZkgbXeoJSDAJuw9Qtx3AjfYC1M0gCPpdTr6VFG7aJH/CizhHaeEmqpBhhZdKpcEwz14FBqUWsmIC489qz3CKyhe2ZK9HWQmA9CAuQK1k9gekD/GISOvZCeQtLkD5SDman4ZkdZp50vfnp4ooZUB9sQmq6cZSyp0sZh6yCPQ4jcBjzjcjlnUgPQXQCcstSDmmqM+t58GgnEQTdGeVhC8nkD46gOuAuszMo7++Z84DyU1TLPdhPyyjKmtdBUZXrBFYJGHjfzZ9f2HcpdEcnRxILx0ivG51fQRIrlxyJ1ocizK/cBYAyU6CuV9KHJEh3QCULycByW7i/LNYBuU8iuW2dTeyFZDuAelZJ/wbs6WUMXTs6coAAAAASUVORK5CYII=)
 */
export const ChatArrowRightIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M12.2 22c.5-.01.66-.84.37-1.24A3 3 0 0 1 15 16h.46c.35 0 .6-.34.56-.69a3 3 0 0 1 5.1-2.43l.06.06c.29.28.77.12.8-.28L22 12a10 10 0 1 0-18.45 5.36c.13.19.11.44-.04.61l-2.06 2.37A1 1 0 0 0 2.2 22h10Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M19.7 14.3a1 1 0 0 0-1.4 1.4l.29.3 2 2H15a1 1 0 0 0 0 2h5.59l-2.3 2.3a1 1 0 0 0 1.42 1.4l4-4a1 1 0 0 0 0-1.4l-2.57-2.58-1.43-1.43Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
